import React, { useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import {
  Home, NoMatch,
  Test, TestResults, TestOverview,
  PracticeTest, PracticeResultsOverview, PracticeTestResults,
  // VPTTest, VPTOverview, VPTThankyou, BookmarkedQuestions, Gamefication, LiveTest, LiveTestResults, LiveTestOverview, CodeEditor
  VPTTest, VPTOverview, VPTThankyou, BookmarkedQuestions, LiveTest, LiveTestResults, LiveTestOverview, CodeEditor
} from "./pages";
import EmailVerify from "./components/User/EmailVerify";
import TestCompleted from "./pages/TestCompleted";

const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useEffect(
    () => {
      window.scrollTo(0, 0);
    },
    [pathname]
  );

  return children;
});

const Routes = () => (
  <ScrollToTop>
    <Switch>
      <Route exact path="/" component={Home} />

      <Route path="/test/:tid" component={Test} exact />
      <Route path="/test/:tid/:qid" component={Test} exact />
      <Route path="/liveTest/:tid" component={LiveTest} exact />
      <Route path="/liveTest/:tid/:qid" component={LiveTest} exact />

      <Route path="/testResults/:tid" component={TestResults} exact />
      <Route path="/testResults/:tid/:qid" component={TestResults} exact />
      <Route path="/testOverview/:tid" component={TestOverview} exact />
      <Route path="/liveTestResults/:tid" component={LiveTestResults} exact />
      <Route path="/liveTestResults/:tid/:qid" component={LiveTestResults} exact />
      <Route path="/liveTestOverview/:tid" component={LiveTestOverview} exact />
      <Route path="/practiceTest" component={PracticeTest} exact />
      <Route path="/practiceTest/:qid" component={PracticeTest} exact />
      <Route path="/practiceTestOverview/:tid" component={PracticeResultsOverview} exact />
      <Route path="/practiceTestOverview/" component={PracticeResultsOverview} exact />
      <Route path="/practiceTestResults/:tid/:qid" component={PracticeTestResults} exact />
      <Route path="/practiceTestResults/:qid" component={PracticeTestResults} exact />
      <Route path="/vpt/overview/" component={VPTOverview} exact />
      <Route path="/vpt/thankyou" component={VPTThankyou} exact />
      <Route path="/bookmarkedQuestions/:subjectId" component={BookmarkedQuestions} exact />
      <Route path="/vpt/test/:tid" component={VPTTest} exact />
      <Route path="/vpt/test/:tid/:qid" component={VPTTest} exact />
      <Route path="/emailVerify" component={EmailVerify} exact />
      {/* <Route path="/gamefication" component={Gamefication} exact /> */}
      <Route path='/codeeditor' component={CodeEditor} exact />
      <Route path='/completed' component={TestCompleted} exact />
      <Route component={NoMatch} />
    </Switch>
  </ScrollToTop>
);

export default Routes;
